import { getRequestId } from "./requestId";

export function apiFetch(url, options = {}) {
  const headers = new Headers(options.headers || {});
  headers.set("X-Request-Id", getRequestId());
  return fetch(url, {
    ...options,
    // Evita If-None-Match → 304 sem corpo (quebra response.json no /who)
    cache: options.cache ?? "no-store",
    credentials: options.credentials ?? "include",
    headers,
  });
}
